import { useRef, useState, useCallback, memo } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import AnimatedNotification from './animatedNotification';
import useOnClickOutside from 'shared/hoc/onclickOutSide';
import MiniNavbar from './miniNavbar';

import { ExternalLinkIcon } from 'shared/icon/icon';

const headerLogo = '/assets/image/logo.jpg';

type MenuItem = {
	label: string;
	to?: string;
	items?: { label: string; to: string }[];
};

const SUB_MENU_STYLE = 'cursor--pointer font-size--sm mb--5 p--5';

const ABOUT_MENU: MenuItem = {
	label: 'About Us',
	items: [
		{ label: 'About Prarthana School', to: '/aboutschool' },
		{ label: 'Mission & vision', to: '/mission&vision' },
		{ label: "Chairman's Message", to: '/chairman' },
		{ label: 'Rules & Regulation', to: '/rules&regulation' },
		{ label: 'School System', to: '/schoolsystem' },
		{ label: 'CBSE Mandatory Disclosure', to: '/cbsemandatorydiscolsure' }
	]
};

const ACADEMICS_MENU: MenuItem = {
	label: 'Academics',
	items: [
		{ label: 'Training', to: '/training' },
		{ label: 'Transfer Certificate', to: '/transfer-certificate' },
		{ label: 'List Of Holidays', to: '/academics/16' },
		{ label: 'Academic Calendar', to: '/academics/10' },
		{ label: 'CCA & Competitions', to: '/academics/17' },
		{ label: 'National Education Policy', to: '/academics/18' },
		{ label: 'Exam Time Table', to: '/academics/19' },
		{ label: 'Fees', to: '/fees/9' }
	]
};

const ACTIVITY_MENU: MenuItem = {
	label: 'Activity',
	items: [
		{ label: 'Co-Curricular Activities', to: '/cocurricularactivity' },
		{ label: 'Sports & Game', to: '/sports&game' },
		{ label: 'Art Room', to: '/art' },
		{ label: 'Music Room', to: '/music' },
		{ label: 'Dance Room', to: '/dance' },
		{ label: 'Housing & Dining', to: '/housing&dining' }
	]
};

const GALLERY_MENU: MenuItem = {
	label: 'Gallery',
	items: [
		{ label: 'Photos', to: '/photo-gallery' },
		{ label: 'Videos', to: '/video-gallery' }
	]
};

export const TopHeader = memo(() => {
	const navigate = useNavigate();
	const [isPopUpOpen, setIsPopUpOpen] = useState(false);
	const closePopRef = useRef<HTMLDivElement>(null);

	const handleOnClosePopUp = useCallback(() => {
		setIsPopUpOpen(false);
	}, []);

	useOnClickOutside(closePopRef, handleOnClosePopUp);

	const renderDropdown = (menu: MenuItem) => (
		<li className='has-dropdown mr--40 text-decoration--none link-text--blue font-size--16px font-weight--600'>
			<Link to='/' className='pointer--none mr--40 text-decoration--none link-text--blue font-size--16px font-weight--600'>
				<span>{menu.label}</span>
			</Link>
			<ul className='dropdown'>
				{menu.items?.map(({ label, to }) => (
					<Link key={to} to={to} className='text-decoration--none link-text--blue'>
						<li className={SUB_MENU_STYLE}>
							<span>{label}</span>
						</li>
					</Link>
				))}
			</ul>
		</li>
	);

	return (
		<div
			ref={closePopRef}
			className='flex width--full justify__content--between align__items--center top--0 position--sticky header-bg pb--5 z-index--1'
		>
			<div className='width--10-per cursor--pointer mr--15' onClick={() => navigate('/')}>
				<img src={headerLogo} alt='prarthana school' className='header-logo' />
			</div>

			<div className='flex width--90-per justify__content--between align__items--center navbar-menu'>
				<div className='header'>
					<ul className='flex no--padding'>
						<li className='mr--40 text-decoration--none link-text--blue font-size--16px font-weight--600'>
							<Link to='/' className='mr--40 text-decoration--none link-text--blue font-size--16px font-weight--600'>
								<span>Home</span>
							</Link>
						</li>

						{renderDropdown(ABOUT_MENU)}
						{renderDropdown(ACADEMICS_MENU)}
						{renderDropdown(ACTIVITY_MENU)}
						{renderDropdown(GALLERY_MENU)}

						<li className='mr--40 text-decoration--none link-text--blue font-size--16px font-weight--600'>
							<Link to='/contactUs' className='mr--40 text-decoration--none link-text--blue font-size--16px font-weight--600'>
								<span>Contact Us</span>
							</Link>
						</li>
					</ul>
				</div>

				<span className='cursor--pointer' onClick={() => setIsPopUpOpen(!isPopUpOpen)}>
					<AnimatedNotification />
				</span>

				<button
					className='primary--btn flex ml--30 font-weight--600 no--border cursor--pointer admission--btn sainik-btn'
					onClick={() => window.open('https://pgssmodasa.com/', '_blank', 'noopener,noreferrer')}
					tabIndex={-1}
				>
					<span className='gov-new-badge'>NEW</span>
					Sainik School
					<span className='ml--5 inline--flex align__items--center'>
						<ExternalLinkIcon />
					</span>
				</button>
			</div>

			<MiniNavbar />

			{isPopUpOpen && (
				<div className='position--absolute notification--popup b-radius--25 pl--20 pr--20'>
					<p className='font-weight--600'>
						ADMISSIONS OPEN
						<br />
						<span className='text-decoration--underline'>OFFICE TIMING:</span> MON-SAT 8 AM TO 1 PM, SUNDAY 10 AM TO 1 PM.
					</p>
				</div>
			)}
		</div>
	);
});
